export default {
  filterNotification: state => () => {
    const sort = state.notifications.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn));
    return sort.reverse();
  },
};
